<template>
  <div class="my-3">
    <label>Set Points</label>
    <div class="border my-2 p-3">
      <div class="row">
        <div class="col-sm-6 col-md-6">
          <h7>
            <strong> Program or contest: {{ name }} </strong>
          </h7>
          <p>
            <strong
              >You have
              {{ parseInt(selectedUsers.length).toLocaleString() }} user/users
              selected to receive points.</strong
            >
          </p>
          <div class="my-3">
            <label>Points Per User</label>
            <b-form-input v-model="PointsPerUser" type="number"></b-form-input>
          </div>
          <div class="my-3">
            <label>Email Notification</label>
            <b-form-checkbox
              id="checkbox-1"
              v-model="EmailNotification"
              name="checkbox-1"
              class="m-1"
            >
            </b-form-checkbox>
          </div>
          <div class="my-3">
            <label>Email Subject</label>
            <b-form-input v-model="EmailSubject"></b-form-input>
          </div>
        </div>
        <div class="col-sm-6 col-md-6">
          <div class="my-3">
            <label>Congratulatory Note</label>
            <b-form-textarea
              v-model="CongratulatoryNote"
              placeholder="Enter Your Message Here..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <small
              >This note will appear on the paricipant's account history.</small
            >
          </div>
          <div class="my-3">
            <label>Email Message</label>
            <b-form-textarea
              v-model="EmailMessage"
              placeholder="Enter Your Message Here..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <small
              >This message will be sent to inform the user of the points
              grant.</small
            >
          </div>
        </div>
      </div>
    </div>
    <!--<div v-if="stripeCustomerId">
      <strong
        >When adding points you will be charged the following amount using the
        payment method on file:</strong
      >
      <h4>Price: ${{ pointCost }}</h4>
      <h4>Unallocated Points that will be added: ${{ unallocDeposit }}</h4>
      <h4>
        Total Cost: ${{
          pointCost - unallocDeposit > 0 ? pointCost - unallocDeposit : 0
        }}
      </h4>
    </div>-->
    <b-button :disabled="this.Loading" @click="updatePoints()" variant="primary" class="m-2"
      >Add Points</b-button
    >
    <div v-if="Loading === true">
      <div class="centered-spinner">
        <a-spin />
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../../../router/index";
import { mapState } from "vuex";
import { ChargeAndAllocate } from "@/api/funding";
export default {
  name: "AddPointsSetPoints",
  data() {
    return {
      selectedUsers: [...this.$store.state.adminAddPoint.SelectedUsers],
      PointsPerUser: 0,
      EmailNotification: false,
      EmailSubject: "",
      name: "",
      CongratulatoryNote: "",
      EmailMessage: "",
      Loading: false,
    };
  },
  computed: {
    ...mapState({
      userDetail: (state) => state.userManager.userDetail,
      companyName: (state) => state.company.name,
      stripeCustomerId: (state) => state.company.stripeCustomerId,
      ratio: (state) => state.company.ratio,
      userClients: (state) => state.user.userClients,
      loggedInUserID: (state) => state.user.profile.id,
      userEmail: (state) => state.user.email,
      unallocDeposit: (state) => state.company.unallocDeposit,
    }),
    pointCost() {
      return (this.PointsPerUser * this.selectedUsers.length) / this.ratio;
    },
  },
  methods: {
    async updatePoints() {
      this.Loading=true
      /*if (this.stripeCustomerId) {
         try {
          const payload = {
            clientID: parseInt(this.userClients.client),
            receiptEmail: this.userEmail,
            description: this.CongratulatoryNote,
            byWhom: this.loggedInUserID,
            points: this.PointsPerUser * this.selectedUsers.length,
          };
          const resp = await ChargeAndAllocate(payload);
          console.log(resp);

          if (resp.status != 200) {
            console.error("did not return 200");
            this.errorMessage = resp.data;
            return;
          }
        } catch (e) {
          console.error(
            `something went wrong allocating points and charging customer. ${e}`
          );
          return
      }
      }*/
      const postBody = {
        userId: this.selectedUsers.map(({ id }) => id),
        clientId: +this.$route.params.clientId,
        programId: Number(this.$route.params.programId),
        type: "points added",
        points: +this.PointsPerUser,
        comment: this.CongratulatoryNote,
        isEmailNotificationOn: this.EmailNotification,
        email_subject: this.EmailSubject,
        email_message: this.EmailMessage,
      };
      this.$store
        .dispatch("adminAddPoint/updateUsersPoints", postBody)
        .then((data) => {
          router.push({
            name: "AdminAddPointsSystemMessage",
            params: { pointsAdded: this.PointsPerUser },
          });
        });
    },
  },
  async created() {
     await this.$store.dispatch("company/fetchCompany"); // TODO all of these things should be persistent
    await this.$store.dispatch("user/fetchProfile");
    if (this.$route.params.programId !== "add") {
      this.Loading = true;
      this.$store
        .dispatch("adminAddPoint/getProgramDetailsById", {
          programId: this.$route.params.programId,
        })
        .then((data) => {
          this.name = data.name;
          this.PointsPerUser = data.presetPoints;
          this.EmailNotification = data.postSummaryNotification;
          this.EmailSubject = data.presetEmailSubject;
          this.CongratulatoryNote = data.presetCongratulatoryNote;
          this.EmailMessage = data.presetEmailMessage;
          this.Loading = false;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
